export function getClientNavigationUrl(fullUrl?: string): string | undefined {
  if (!fullUrl) {
    return fullUrl;
  }

  try {
    const { host, pathname, search, hash } = new URL(fullUrl, window.location.origin);

    /**
     * Клиентская навигация невозможна между разными хостами (например, при смене города меняется субдомен),
     * такой переход должен выполняться полной перезагрузкой страницы
     */
    if (host !== window.location.host) {
      return undefined;
    }

    return `${pathname}${search}${hash}`;
  } catch {
    return fullUrl.startsWith('/') ? fullUrl : undefined;
  }
}
